import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';

export interface CollegeAreaOfStudy {
  id: number;
  name: string;
}

const URL = '/v2/college-area-of-study';

class CollegeAreaOfStudyService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<CollegeAreaOfStudy>> {
    return axios.get(URL, config);
  }
}

export { CollegeAreaOfStudyService };
